<div mat-dialog-content style="width: 400px">
  <lemon-dialog-header> Lisää tiedosto </lemon-dialog-header>

  <form>
    <div style="margin: 2rem">
      <div style="margin: 2rem 0">
        @if (!uploadedFile()?.fileName) {
          <app-primary-button (click)="fileInput.click()" actionId="Valitse tiedosto ladattavaksi arkistoon"> Valitse tiedosto </app-primary-button>
        } @else {
          <div>{{ uploadedFile()?.fileName }}</div>
        }
      </div>

      @if (latausVirheObservable | async; as latausVirhe) {
        <div class="error-box">{{ latausVirhe }}</div>
      }

      <mat-form-field style="width: 100%" floatLabel="always">
        <mat-label>Tilikausi</mat-label>
        <mat-select [formField]="lomake.tilikausiAvaimet" multiple placeholder="Kaikki tilikaudet">
          @for (tk of tilikaudet; track tk) {
            <mat-option [value]="tk.avain"> {{ tk.alkaa | lokaalipvm | async }} – {{ tk.loppuu | lokaalipvm | async }} </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Tyyppi</mat-label>
        <mat-select [formField]="lomake.tiedostoTyyppi">
          @for (tyyppi of kayttajanTiedostotyypit; track tyyppi) {
            <mat-option [value]="tyyppi.arvo">
              {{ tyyppi.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <mat-label>Lisätiedot</mat-label>
        <input [formField]="lomake.lisatiedot" matInput data-lpignore="true" />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <app-secondary-button mat-dialog-close actionId="Peruuta (arkistoon lataus dialog)" styles="margin-right: 20px;">Peruuta</app-secondary-button>
  <app-primary-button [disabled]="!uploadedFile()" (click)="save()" actionId="Tallennettu tiedosto arkistoon" [actionContext]="[uploadedFile()?.fileName]">Tallenna</app-primary-button>
</div>

<input style="visibility: hidden; height: 1px" (change)="upload($event)" type="file" accept="*" #fileInput multiple="multiple" />
